export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g transform="translate(5.833 5)" fill="#FFF" fillRule="evenodd">
                <rect width="2.778" height="10" rx="1.091" />
                <rect x="5.556" width="2.778" height="10" rx="1.091" />
            </g>
        </svg>
    );
}
